import React from 'react';
import './section.scss';
export var Section = function (_a) {
    var title = _a.title, headerChildren = _a.headerChildren, children = _a.children, mb = _a.mb, className = _a.className;
    var sectionClasses = "c-section ".concat(className !== null && className !== void 0 ? className : '');
    if (mb) {
        sectionClasses += " u-mb-".concat(mb);
    }
    return (React.createElement("section", { className: sectionClasses },
        React.createElement("header", { className: "c-section__header" },
            React.createElement("h3", null, title),
            headerChildren),
        React.createElement("div", { className: "c-section__body" }, children)));
};
